import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../../../../components/src/lib/home/home.component';
import { routeGuardFn } from '../../../../components/src/lib/shared/services/route-guard.service';
import { LoginComponent } from '../../../../components/src/lib/login/login.component';
import { loginRouteGuardFn } from '../../../../components/src/lib/shared/services/login-guard-service';
import { LogoutComponent } from '../../../../components/src/lib/shared/logout/logout.component';
import { ZiroSearchComponent } from '../../../../components/src/lib/helpdesk/search/search.component';
import {
  ziroFormConfirmRouteChangeGuardFn,
  ZiroFormConfirmRouteChangeService,
} from '../../../../components/src/lib/forms/ziro-form-confirm-route-change.service';
import { SelfServeComponent } from '../../../../components/src/lib/self-serve/self-serve.component';
import { SelfServeUserDetailsComponent } from '../../../../components/src/lib/self-serve/self-serve-user-details/self-serve-user-details.component';
import { SelfServeDeskphoneEditComponent } from '../../../../components/src/lib/self-serve/self-serve-edit-deskphone/self-serve-deskphone-edit.component';
import { SelfServeVmPinResetComponent } from '../../../../components/src/lib/self-serve/self-serve-pin-reset/self-serve-vm-pin-reset/self-serve-vm-pin-reset.component';
import { SelfServeEmPinResetComponent } from '../../../../components/src/lib/self-serve/self-serve-pin-reset/self-serve-em-pin-reset/self-serve-em-pin-reset.component';
import { SelfServeCallForwardEditComponent } from '../../../../components/src/lib/self-serve/self-serve-call-forward-edit/self-serve-call-forward-edit.component';
import { SelfServeSnrEditComponent } from '../../../../components/src/lib/self-serve/self-serve-snr-edit/self-serve-snr-edit.component';
import { ActivateDeskphoneComponent } from '../../../../components/src/lib/self-serve/activate-deskphone/activate-deskphone.component';
import { SelfServeReplaceDeskphoneComponent } from '../../../../components/src/lib/self-serve/self-serve-replace-deskphone/self-serve-replace-deskphone.component';
import { deskphoneRouteGuardFn } from '../../../../components/src/lib/shared/services/activate-deskphone-route-guard.service';
import { SystemStatusComponent } from '../../../../components/src/lib/system-status/system-status.component';
import { UserDetailComponent } from '../../../../components/src/lib/helpdesk/cisco/user-detail/user-detail.component';
import { ZiroUserDetailHomeComponent } from '../../../../components/src/lib/helpdesk/cisco/user-detail-home/user-detail-home.component';
import { SnrComponent } from '../../../../components/src/lib/helpdesk/cisco/snr/snr.component';
import { UccxAgentComponent } from '../../../../components/src/lib/helpdesk/cisco/uccx-agent/uccx-agent.component';
import { PcceAgentSettingsComponent } from '../../../../components/src/lib/helpdesk/cisco/pcce-agent-settings/pcce-agent-settings.component';
import { ZiroDirectoryNumberFormComponent } from '../../../../components/src/lib/helpdesk/cisco/directory-number/directory-number-form.component';
import { UserDetailPhoneComponent } from '../../../../components/src/lib/helpdesk/cisco/user-detail/user-detail-phone/user-detail-phone.component';
import { UserDetailVoicemailComponent } from '../../../../components/src/lib/helpdesk/cisco/user-detail/user-detail-voicemail/user-detail-voicemail.component';
import { UserPinResetComponent } from '../../../../components/src/lib/helpdesk/cisco/user-pin-reset/user-pin-reset.component';
import { ChangeSiteComponent } from '../../../../components/src/lib/helpdesk/cisco/change-site/change-site.component';
import { MakePublicComponent } from '../../../../components/src/lib/helpdesk/cisco/make-public/make-public.component';
import { SendEmailComponent } from '../../../../components/src/lib/helpdesk/cisco/send-email/send-email.component';
import { WebexCallingComponent } from '../../../../components/src/lib/helpdesk/cisco/webex-calling/webex-calling.component';
import { ReassignUserComponent } from '../../../../components/src/lib/helpdesk/cisco/reassign-user/reassign-user.component';
import { PublicPhoneComponent } from '../../../../components/src/lib/helpdesk/cisco/public-phone/public-phone.component';
import { PublicPhoneContainerComponent } from '../../../../components/src/lib/helpdesk/cisco/public-phone/public-phone-container/public-phone-container.component';
import { PublicPhoneChangeSiteComponent } from '../../../../components/src/lib/helpdesk/cisco/public-phone/public-phone-change-site/public-phone-change-site.component';
import { PublicPhonePinResetComponent } from '../../../../components/src/lib/helpdesk/cisco/public-phone/public-phone-pin-reset/public-phone-pin-reset.component';
import { PublicPhoneReassignComponent } from '../../../../components/src/lib/helpdesk/cisco/public-phone/public-phone-reassign/public-phone-reassign.component';
import { SearchResultPinResetComponent } from '../../../../components/src/lib/helpdesk/search/search-result-pin-reset/search-result-pin-reset.component';
import { ZiroCdrDumpComponent } from '../../../../components/src/lib/cdr-dump/cdr-dump.component';
import { AddUserComponent } from '../../../../components/src/lib/helpdesk/cisco/add-user/add-user.component';
import { SupportComponent } from '../../../../components/src/lib/shared/support/support.component';
import { DistributionListComponent } from '../../../../components/src/lib/helpdesk/cisco/distribution-list/distribution-list.component';
import { AddMemberToDistributionListComponent } from '../../../../components/src/lib/helpdesk/cisco/distribution-list/add-member-to-distribution-list.component';
import { MigrationsComponent } from '../../../../components/src/lib/migrations/migrations.component';
import { MigrationsTableComponent } from '../../../../components/src/lib/migrations/migrations-table/migrations-table.component';
import { MigrationsCreateComponent } from '../../../../components/src/lib/migrations/migrations-create/migrations-create.component';
import { MigrationsCiscoHuntListsReportComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-hunt-list-report/migrations-cisco-hunt-lists-report.component';
import { MigrationsCiscoHuntListsReportLineGroupsComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-hunt-list-report/migrations-hunt-list-report-line-groups/migrations-cisco-hunt-lists-report-line-groups.component';
import { MigrationsCiscoDirectoryNumbersReportComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-directory-number-report/migrations-cisco-directory-numbers-report.component';
import { MigrationsCiscoComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco.component';
import { MigrationsCiscoDashboardComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-dashboard/migrations-cisco-dashboard.component';
import { MigrationsAutoAttendantsComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendants.component';
import { MigrationsAutoAttendantsDetailedViewComponent } from '../../../../components/src/lib/migrations/migrations-cisco/migrations-cisco-auto-attendant-report/migrations-auto-attendants-detailed-view/migrations-auto-attendants-detailed-view.component';
import { zpmHelpdeskRoutes } from './zpm-helpdesk-routes';
import { MigrationsRingCentralComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/migrations-ring-central.component';
import { MigrationsRingCentralNumbersReportComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/migrations-ring-central-numbers-report/migrations-ring-central-numbers-report.component';
import { MigrationsRingCentralDashboardComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/migrations-ring-central-dashboard/migrations-ring-central-dashboard.component';
import { RingCentralCallQueueComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/ring-central-call-queues/ring-central-call-queue/ring-central-call-queue.component';
import { RingCentralCallQueuesListViewComponent } from '../../../../components/src/lib/migrations/migrations-ring-central/ring-central-call-queues/ring-central-call-queues-list-view/ring-central-call-queues-list-view.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [routeGuardFn],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;pages.home.title',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginRouteGuardFn],
    data: {
      title: 'tkey;pages.login.title',
    },
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [routeGuardFn],
  },
  {
    path: 'search',
    component: ZiroSearchComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    children: [
      {
        path: '?query',
        component: ZiroSearchComponent,
        canActivate: [routeGuardFn],
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'admin',
    loadChildren: () => import('../../../../components/src/lib/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'ziro-support',
    loadChildren: () =>
      import('../../../../components/src/lib/support/ziro-support.module').then((m) => m.ZiroSupportModule),
  },
  { path: 'zero-touch', redirectTo: 'automations' },
  {
    path: 'automations',
    loadChildren: () =>
      import('../../../../components/src/lib/automations/automations.module').then((m) => m.AutomationsModule),
  },
  {
    path: 'self-serve',
    canActivate: [routeGuardFn],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/',
      },
      {
        path: 'user',
        canActivate: [routeGuardFn],
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/',
          },
          {
            path: ':username',
            component: SelfServeComponent,
            canActivate: [routeGuardFn],
            children: [
              {
                path: '',
                component: SelfServeUserDetailsComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'phone/:phoneId',
                component: SelfServeDeskphoneEditComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'voicemail-pin-reset/:voicemailId',
                component: SelfServeVmPinResetComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'extension-mobility-pin-reset/:extensionMobilityId',
                component: SelfServeEmPinResetComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'call-forward/:dnId',
                component: SelfServeCallForwardEditComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'snr-destination/:destinationId',
                component: SelfServeSnrEditComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'snr-profile/:snrProfileId/snr-destination',
                component: SelfServeSnrEditComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'activate',
                component: ActivateDeskphoneComponent,
                canActivate: [routeGuardFn],
                canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
              {
                path: 'replace-deskphone/:phoneId',
                component: SelfServeReplaceDeskphoneComponent,
                canActivate: [routeGuardFn],
                data: {
                  title: 'tkey;pages.title.selfserve',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  { path: 'activate', canActivate: [routeGuardFn, deskphoneRouteGuardFn], children: [] },
  { path: 'report', redirectTo: 'reports' },
  { path: 'control', redirectTo: 'reports' },
  {
    path: 'reports',
    loadChildren: () =>
      import('../../../../components/src/lib/reporting/reporting.module').then((m) => m.ReportingModule),
  },
  { path: 'system-status', redirectTo: 'system-health-status', pathMatch: 'full' },
  {
    path: 'system-health-status',
    component: SystemStatusComponent,
    data: {
      title: 'tkey;system_status.title',
    },
  },
  {
    path: 'emergency-calling-management',
    loadChildren: () =>
      import('../../../../components/src/lib/emergency-calling/emergency-calling.module').then(
        (m) => m.EmergencyCallingModule,
      ),
  },
  {
    path: 'resource-account-management',
    loadChildren: () =>
      import('../../../../components/src/lib/resource-accounts/resource-account.module').then(
        (m) => m.ResourceAccountModule,
      ),
  },
  {
    path: 'call-queue-management',
    loadChildren: () =>
      import('../../../../components/src/lib/teams-call-queues/teams-call-queue.module').then(
        (m) => m.TeamsCallQueueModule,
      ),
  },
  {
    path: 'auto-attendant-management',
    loadChildren: () =>
      import('../../../../components/src/lib/teams-auto-attendants/teams-auto-attendant.module').then(
        (m) => m.TeamsAutoAttendantModule,
      ),
  },
  {
    path: 'user/:username',
    component: UserDetailComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    children: [
      {
        path: '',
        component: ZiroUserDetailHomeComponent,
        data: {
          title: 'tkey;pages.details.title',
          breadcrumb: 'tkey;userdetail.breadcrumb.home.text',
        },
      },
      {
        path: 'snr/:profileId',
        component: SnrComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;snr.page.title',
          breadcrumb: 'tkey;snr.page.title',
        },
      },
      {
        path: 'snr',
        component: SnrComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;snr.page.title',
          breadcrumb: 'tkey;snr.page.title',
        },
      },
      {
        path: 'uccx-agent/:serverId',
        component: UccxAgentComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;pages.details.title',
          breadcrumb: 'tkey;shared.service.agent.text',
        },
      },
      {
        path: 'pcce-agent-settings',
        component: PcceAgentSettingsComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;pcce.agent_settings.title',
          breadcrumb: 'tkey;pcce.agent_settings.title',
        },
      },
      {
        path: 'primary-extension',
        pathMatch: 'full',
        component: ZiroDirectoryNumberFormComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;pages.details.title',
          breadcrumb: 'tkey;shared.service.primary.extension.text',
        },
      },
      {
        path: 'primary-extension/:dnId',
        pathMatch: 'full',
        component: ZiroDirectoryNumberFormComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;pages.details.title',
          breadcrumb: 'tkey;shared.service.primary.extension.text',
        },
      },
      {
        path: 'deskphone',
        pathMatch: 'full',
        component: UserDetailPhoneComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;shared.model.deskphone.text',
          breadcrumb: 'tkey;shared.model.deskphone.text',
        },
      },
      {
        path: 'deskphone/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;shared.model.deskphone.text',
          breadcrumb: 'tkey;shared.model.deskphone.text',
        },
      },
      {
        path: 'deskphone/:phoneId/copy',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;shared.model.deskphone.text',
          breadcrumb: 'tkey;shared.model.deskphone.text',
        },
      },
      {
        path: 'voicemail',
        component: UserDetailVoicemailComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'Voicemail',
          breadcrumb: 'tkey;userdetail.voicemail.title',
        },
      },
      {
        path: 'voicemail/:voicemailId',
        component: UserDetailVoicemailComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'Voicemail',
          breadcrumb: 'tkey;userdetail.voicemail.title',
        },
      },
      {
        path: 'iphone',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.iphone.page.title',
          breadcrumb: 'tkey;userdetail.iphone.page.title',
        },
      },
      {
        path: 'iphone/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.iphone.page.title',
          breadcrumb: 'tkey;userdetail.iphone.page.title',
        },
      },
      {
        path: 'android',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.android.page.title',
          breadcrumb: 'tkey;userdetail.android.page.title',
        },
      },
      {
        path: 'android/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.android.page.title',
          breadcrumb: 'tkey;userdetail.android.page.title',
        },
      },
      {
        path: 'extension-mobility',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.extension_mobility.page.title',
          breadcrumb: 'tkey;userdetail.extension_mobility.page.title',
        },
      },
      {
        path: 'extension-mobility/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.extension_mobility.page.title',
          breadcrumb: 'tkey;userdetail.extension_mobility.page.title',
        },
      },
      {
        path: 'pin-reset',
        component: UserPinResetComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;pages.pinreset.title',
          breadcrumb: 'tkey;pages.pinreset.title',
        },
      },
      {
        path: 'tablet',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.tablet.page.title',
          breadcrumb: 'tkey;userdetail.tablet.page.title',
        },
      },
      {
        path: 'tablet/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.tablet.page.title',
          breadcrumb: 'tkey;userdetail.tablet.page.title',
        },
      },
      {
        path: 'im-softphone',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.imSoftphone.page.title',
          breadcrumb: 'tkey;userdetail.imSoftphone.page.title',
        },
      },
      {
        path: 'im-softphone/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.imSoftphone.page.title',
          breadcrumb: 'tkey;userdetail.imSoftphone.page.title',
        },
      },
      {
        path: 'change-site',
        component: ChangeSiteComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;change.site.change_site',
        },
      },
      {
        path: 'make-public',
        component: MakePublicComponent,
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;transfer.menu.to.public',
        },
      },
      {
        path: 'send-email',
        component: SendEmailComponent,
        data: {
          title: 'tkey;helpdesk.send_email.table.title',
          breadcrumb: 'tkey;helpdesk.send_email.table.title',
        },
      },
      {
        path: 'webex-calling/:email',
        pathMatch: 'full',
        component: WebexCallingComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;pages.details.title',
          breadcrumb: 'tkey;shared.service.webex_calling.text',
        },
      },
      {
        path: 'cipc',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.cipc.page.title',
          breadcrumb: 'tkey;userdetail.cipc.page.title',
        },
      },
      {
        path: 'cipc/:phoneId',
        component: UserDetailPhoneComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
        data: {
          title: 'tkey;userdetail.cipc.page.title',
          breadcrumb: 'tkey;userdetail.cipc.page.title',
        },
      },
      {
        path: 'reassign',
        component: ReassignUserComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;pages.reassign.title',
          breadcrumb: 'tkey;pages.reassign.title',
        },
      },
      {
        path: 'reassign/:targetUsername',
        component: ReassignUserComponent,
        pathMatch: 'full',
        canActivate: [routeGuardFn],
        data: {
          title: 'tkey;pages.reassign.title',
        },
      },
    ],
  },
  {
    path: 'phone/:phoneId/line/:lineNum/directory-number',
    component: ZiroDirectoryNumberFormComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;pages.details.title',
    },
  },
  {
    path: 'phone/:phoneId/line/:lineNum/directory-number/:dnId',
    component: ZiroDirectoryNumberFormComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;pages.details.title',
    },
  },
  {
    path: 'public-phone',
    canActivate: [routeGuardFn],
    children: [
      {
        path: '',
        component: PublicPhoneComponent,
        data: {
          title: 'tkey;pages.phone.title',
        },
        children: [
          {
            path: '',
            component: PublicPhoneContainerComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
            data: {
              title: 'tkey;pages.phone.title',
            },
          },
        ],
      },
      {
        path: ':phoneName',
        component: PublicPhoneComponent,
        data: {
          title: 'tkey;pages.phone.title',
        },
        children: [
          {
            path: '',
            component: PublicPhoneContainerComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
            data: {
              title: 'tkey;pages.phone.title',
            },
          },
          {
            path: 'change-site',
            component: PublicPhoneChangeSiteComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
            data: {
              title: 'tkey;pages.phone.title',
              breadcrumb: 'tkey;change.site.change_site',
            },
          },
          {
            path: 'pin-reset',
            component: PublicPhonePinResetComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
            data: {
              title: 'tkey;pages.pinreset.title',
              breadcrumb: 'tkey;pages.pinreset.title',
            },
          },
          {
            path: 'copy',
            component: PublicPhoneContainerComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
            data: {
              title: 'tkey;pages.phone.title',
            },
          },
          {
            path: 'reassign',
            component: PublicPhoneReassignComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
          },
          {
            path: 'reassign/:username',
            component: PublicPhoneReassignComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
          },
          {
            path: 'reassign/:search',
            component: PublicPhoneReassignComponent,
            canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
          },
        ],
      },
    ],
  },
  {
    path: 'search',
    component: ZiroSearchComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;search.title',
    },
  },
  {
    path: 'unity-servers/:serverId/voicemails/:voicemailId/pin-reset',
    component: SearchResultPinResetComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;pages.pinreset.title',
    },
  },
  {
    path: 'cdr-dump',
    component: ZiroCdrDumpComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;cdr_dump.title',
    },
  },
  {
    path: 'user-add',
    component: AddUserComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    pathMatch: 'full',
    data: {
      title: 'tkey;pages.useradd.success.newUser',
    },
  },
  {
    path: 'support',
    component: SupportComponent,
    pathMatch: 'full',
  },
  {
    path: 'server/:serverid/distribution-list/:distributionlistid',
    component: DistributionListComponent,
    canActivate: [routeGuardFn],
    canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
    pathMatch: 'full',
    data: {
      title: 'tkey;pages.distributionlist.pagetitle',
    },
  },
  {
    path: 'server/:serverid/distribution-list/:distributionlistid/add',
    component: AddMemberToDistributionListComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;pages.distributionlist.add.pagetitle',
      breadcrumb: 'tkey;pages.distributionlist.add.pagetitle',
    },
  },
  {
    path: 'migrations/tenants/:tenantId',
    component: MigrationsComponent,
    canActivate: [routeGuardFn],
    data: {
      title: 'tkey;migrations.title',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: MigrationsTableComponent,
      },
      {
        path: 'new',
        component: MigrationsCreateComponent,
        canActivate: [routeGuardFn],
        canDeactivate: [ziroFormConfirmRouteChangeGuardFn],
      },
      {
        path: 'cisco',
        data: { pbxType: 'cisco' },
        children: [
          {
            path: ':id',
            component: MigrationsCiscoComponent,
            canActivate: [routeGuardFn],
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MigrationsCiscoDashboardComponent,
              },
              {
                path: 'cucm-directory-numbers-report',
                component: MigrationsCiscoDirectoryNumbersReportComponent,
              },
              {
                path: 'cucm-directory-numbers-report/:filter',
                component: MigrationsCiscoDirectoryNumbersReportComponent,
              },
              {
                path: 'cucm-hunt-lists-report',
                component: MigrationsCiscoHuntListsReportComponent,
              },
              {
                path: 'cucm-hunt-lists-report/:name',
                component: MigrationsCiscoHuntListsReportLineGroupsComponent,
              },
              {
                path: 'cuc-auto-attendants-report/call-handler',
                component: MigrationsAutoAttendantsDetailedViewComponent,
              },
              {
                path: 'cuc-auto-attendants-report',
                component: MigrationsAutoAttendantsComponent,
              },
              {
                path: 'cuc-auto-attendants-report/:filter',
                pathMatch: 'full',
                component: MigrationsAutoAttendantsComponent,
              },
            ],
          },
        ],
      },
      {
        path: 'ring-central',
        data: { pbxType: 'ring-central' },
        children: [
          {
            path: ':id',
            component: MigrationsRingCentralComponent,
            canActivate: [routeGuardFn],
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MigrationsRingCentralDashboardComponent,
              },
              {
                path: 'numbers-report',
                component: MigrationsRingCentralNumbersReportComponent,
              },
              {
                path: 'numbers-report/:filter',
                component: MigrationsRingCentralNumbersReportComponent,
              },
              {
                path: 'call-queues',
                component: RingCentralCallQueuesListViewComponent,
              },
              {
                path: 'call-queues/:callQueueId',
                component: RingCentralCallQueueComponent,
              },
            ],
          },
        ],
      },
    ],
  },
  ...zpmHelpdeskRoutes,
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  providers: [ZiroFormConfirmRouteChangeService],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
